import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  SENSEMAKER_LIST_CARD_GRID_GAP_PX,
  SENSEMAKER_LIST_CARD_MIN_HEIGHT_PX,
  SENSEMAKER_LIST_PILL_GAP_PX,
  SENSEMAKER_LIST_PILLS_TO_GRID_GAP_PX,
  SENSEMAKER_LIST_TITLE_ROW_TO_PILLS_GAP_PX,
  SENSEMAKER_LIST_TITLE_SUBTITLE_GAP_PX,
} from '../lib/sensemaker-list-layout'

export function SensemakerListPageSkeleton() {
  return (
    <Box data-testid="sensemaker-list-page-skeleton" aria-busy aria-label="Loading sensemaker list">
      <Box sx={{ mb: `${SENSEMAKER_LIST_TITLE_ROW_TO_PILLS_GAP_PX}px` }}>
        <Skeleton variant="text" width={280} height={32} />
        <Box sx={{ mt: `${SENSEMAKER_LIST_TITLE_SUBTITLE_GAP_PX}px` }}>
          <Skeleton variant="text" width={360} height={20} />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: `${SENSEMAKER_LIST_PILL_GAP_PX}px`,
          mb: `${SENSEMAKER_LIST_PILLS_TO_GRID_GAP_PX}px`,
        }}
      >
        {[1, 2, 3, 4].map((n) => (
          <Skeleton key={n} variant="rounded" width={120} height={32} sx={{ borderRadius: '100px' }} />
        ))}
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' },
          gap: `${SENSEMAKER_LIST_CARD_GRID_GAP_PX}px`,
        }}
      >
        {[1, 2, 3, 4, 5, 6].map((n) => (
          <Skeleton
            key={n}
            variant="rounded"
            height={SENSEMAKER_LIST_CARD_MIN_HEIGHT_PX}
            sx={{ borderRadius: '10px' }}
          />
        ))}
      </Box>
    </Box>
  )
}
